import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectionList } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useMemo, } from 'react';
import { categoryTitles } from 'components/categorizedList/utils/categories';
import { useIntersectionObserver } from 'utils/useIntersectionObserver';
import styles from './categorizedListCategories.module.scss';
import { CreateItem } from './components/createItem/createItem';
import { EmptyItem } from './components/emptyItem/emptyItem';
import { FavoriteItemLayout } from './components/favoriteItemLayout/favoriteItemLayout';
import { LoadingItem } from './components/loadingItem/loadingItem';
/** Represents the list of categories. */
export const CategorizedListCategories = ({ categories, selectedItems, asyncStatus, hasNextPage, isMultiple, isActive, searchTerm, ItemContent, CreateItemContent, isItemFavorite, isItemDisabled = () => false, identityFn, nextPage, refetch, onChange, setCategoriesElement, setCategoriesSectionElements, setVisibleCategoryIds, }) => {
    const { observeElement } = useIntersectionObserver({
        onIntersection: (entry) => {
            const { dataset } = entry.target;
            const categoryId = dataset.id;
            setVisibleCategoryIds((visibleCategoryIds) => {
                if (entry.isIntersecting) {
                    return visibleCategoryIds.every((id) => id !== categoryId)
                        ? visibleCategoryIds.concat(categoryId)
                        : visibleCategoryIds;
                }
                return visibleCategoryIds.some((id) => id === categoryId)
                    ? visibleCategoryIds.filter((id) => id !== categoryId)
                    : visibleCategoryIds;
            });
        },
    });
    /** Handles setting the categories section ref element. */
    const setCategoriesSectionElement = useCallback((categoryElement) => {
        if (categoryElement) {
            const categoryId = categoryElement.dataset
                .id;
            observeElement(categoryElement);
            setCategoriesSectionElements((categoriesSectionElements) => (Object.assign(Object.assign({}, categoriesSectionElements), { [categoryId]: categoryElement })));
        }
    }, [observeElement, setCategoriesSectionElements]);
    const showEmpty = useMemo(() => asyncStatus === 'fulfilled' &&
        categories.length === 1 &&
        categories[0].id === 'paginated' &&
        categories[0].items.length === 0, [asyncStatus, categories]);
    return (_jsxs(SelectionList, Object.assign({ className: styles.root, ref: setCategoriesElement, selectedValues: selectedItems, isMultiple: isMultiple, isActive: isActive, onChange: onChange, equalityFn: (a, b) => identityFn(a) === identityFn(b), defaultActiveItemIndex: CreateItemContent ? 1 : 0 }, { children: [CreateItemContent && (_jsx(CreateItem, Object.assign({ searchTerm: searchTerm, refetch: refetch }, { children: _jsx(CreateItemContent, {}) }))), categories.map((category) => (_jsxs(SelectionList.Section, Object.assign({ "data-id": category.id, ref: setCategoriesSectionElement, className: styles.section, title: categoryTitles[category.id] }, { children: [category.items.map((item) => (_jsx(SelectionList.Item, Object.assign({ value: item, isDisabled: isItemDisabled(item), contentClassName: classnames({
                            [styles.disabled]: isItemDisabled(item),
                        }) }, { children: _jsx(FavoriteItemLayout, Object.assign({ item: item, isFavorite: isItemFavorite(item), isDisabled: isItemDisabled(item) }, { children: _jsx(ItemContent, {}) })) }), identityFn(item)))), showEmpty && _jsx(EmptyItem, { searchTerm: searchTerm })] }), category.id))), _jsx(LoadingItem, { asyncStatus: asyncStatus, hasNextPage: hasNextPage, nextPage: nextPage })] })));
};
